"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames3 = _interopRequireDefault(require("classnames"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../../elements/button/Button");
var _buttonsToDisplay = _interopRequireDefault(require("../../utils/button-carousel/buttonsToDisplay"));
var _buttonCarouselModule = _interopRequireDefault(require("./button-carousel.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["buttonKey", "buttonUrl", "buttonText", "className"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var propTypes = {
  /** Array of objects containing button properties */
  buttonList: _propTypes.default.arrayOf(_propTypes.default.object),
  isCentred: _propTypes.default.bool,
  className: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  hasLargeButtons: _propTypes.default.bool
};
var ButtonCarousel = function ButtonCarousel(_ref) {
  var _ref$buttonList = _ref.buttonList,
    buttonList = _ref$buttonList === void 0 ? [] : _ref$buttonList,
    _ref$isCentred = _ref.isCentred,
    isCentred = _ref$isCentred === void 0 ? false : _ref$isCentred,
    className = _ref.className,
    ariaLabel = _ref.ariaLabel,
    _ref$hasLargeButtons = _ref.hasLargeButtons,
    hasLargeButtons = _ref$hasLargeButtons === void 0 ? false : _ref$hasLargeButtons;
  var TotalNumberOfButtons = buttonList.length;
  var ref = (0, _react.useRef)();
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpanded = _useState4[0],
    setIsExpanded = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isReady = _useState6[0],
    setIsReady = _useState6[1];
  var _useState7 = (0, _react.useState)(TotalNumberOfButtons),
    _useState8 = _slicedToArray(_useState7, 2),
    numberOfButtonsToShow = _useState8[0],
    setNumberOfButtonstoShow = _useState8[1];
  var numberHidden = TotalNumberOfButtons - numberOfButtonsToShow;
  var mobileUpper = 768;
  var updateIsMobile = function updateIsMobile() {
    setIsMobile(window.innerWidth < mobileUpper);
  };
  var findNextFocus = function findNextFocus(nextButton) {
    if (ref.current && ref.current.querySelector) {
      ref.current.querySelector("[data-ind=\"".concat(nextButton, "\"]")).focus();
    }
  };
  var updateNumberOfButtonsToShow = function updateNumberOfButtonsToShow() {
    var newButtonsWidths = [];
    var containerWidth = ref.current && ref.current.offsetWidth || 0;
    var anchorTags = ref.current && ref.current.querySelectorAll && ref.current.querySelectorAll('a:not([data-testid^="show"]), button:not([data-testid^="show"])');
    if (anchorTags) {
      anchorTags.forEach(function (element) {
        if (element) {
          newButtonsWidths.push(element.offsetWidth);
        }
      });
    }
    setNumberOfButtonstoShow((0, _buttonsToDisplay.default)(newButtonsWidths, containerWidth));
  };
  var handleResize = (0, _debounce.default)(function () {
    updateIsMobile();
    updateNumberOfButtonsToShow();
  });
  (0, _react.useLayoutEffect)(function () {
    updateNumberOfButtonsToShow();
    updateIsMobile();
    setIsReady(true);
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  (0, _react.useEffect)(function () {
    updateNumberOfButtonsToShow();
  }, [buttonList]);
  (0, _react.useEffect)(function () {
    if (isExpanded) {
      findNextFocus(numberOfButtonsToShow);
    } else if (isReady) {
      findNextFocus(0);
    }
  }, [isExpanded]);
  var buttonTag = function buttonTag(button, index) {
    var buttonKey = button.buttonKey,
      buttonUrl = button.buttonUrl,
      buttonText = button.buttonText,
      buttonClass = button.className,
      rest = _objectWithoutProperties(button, _excluded);
    var buttonProps = _objectSpread({
      href: buttonUrl,
      children: buttonText
    }, rest);
    if (!hasLargeButtons) {
      buttonProps.size = 'responsive';
    }
    var isHidden = !isMobile && !isExpanded && index + 1 > numberOfButtonsToShow;
    buttonProps.className = (0, _classnames3.default)(buttonClass, _buttonCarouselModule.default.button, _defineProperty(_defineProperty({}, _buttonCarouselModule.default.hide, isHidden), _buttonCarouselModule.default['button--large'], hasLargeButtons));
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, _objectSpread({
      "data-ind": index,
      inline: true
    }, buttonProps), buttonKey ? buttonKey : "button".concat(index));
  };
  return buttonList.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: ref,
    "aria-label": ariaLabel || "Group of ".concat(TotalNumberOfButtons, " buttons"),
    className: (0, _classnames3.default)(className, _buttonCarouselModule.default.slider, _defineProperty(_defineProperty(_defineProperty({}, _buttonCarouselModule.default.isCentred, isCentred), _buttonCarouselModule.default.visibleSlider, isMobile), _buttonCarouselModule.default.isReady, isReady)),
    "data-jlds": true,
    children: [buttonList.map(function (button, index) {
      return buttonTag(button, index);
    }), !isMobile && !isExpanded && numberHidden > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, {
      "aria-label": "Show ".concat(numberHidden, " more"),
      className: _buttonCarouselModule.default.button,
      "data-testid": "show-more",
      inline: true,
      onClick: function onClick() {
        setIsExpanded(true);
      },
      children: "+ ".concat(numberHidden)
    }), !isMobile && isExpanded && numberHidden > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, {
      className: _buttonCarouselModule.default.button,
      "data-testid": "show-less",
      inline: true,
      onClick: function onClick() {
        setIsExpanded(false);
      },
      children: "Show less"
    })]
  });
};
ButtonCarousel.propTypes = propTypes;
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(ButtonCarousel);